import UTILS from '../utils';
import postPlugin from './postPlugin';
import { getPostForEdit } from '../../api/post';
import postButton from '../../components/post/PostButton';
import commentTile from '../../components/common/CommentTile';

const plugin = {
  mixins: [postPlugin],
  components: {
    'post-button': postButton,
    'comment-tile': commentTile,
  },
  props: {
    initPost: { type: Object, required: true },
  },
  data: function() {
    return {
      post: this.initPost,
      cms: null,
    };
  },
  mounted() {
    this.setCms(this.cid);
  },
  watch: {
    cid(n, o) {
      this.setCms(n);
    },
    initPost(n, o) {
      this.post = n;
      this.stopLoading();
    },
  },
  computed: {
    cid() {
      return this.post ? this.post.community_id : 0;
    },
    isExpired() {
      return this.isPast(this.post.expire_at);
    },
    isCompleted() {
      return UTILS.isPostCompleted(this.post);
    },
    canAnswer() {
      return !this.post.completed_at && !this.isExpired;
    },
    isAnswered() {
      return !!this.post.answered;
    },
  },
  methods: {
    getPostNameWithCb(post, cb) {
      if (!post) return cb(null);
      var self = this;
      UTILS.getAllGroupsAndMembers(talk.cid, r => {
        cb(self.getTalkName(talk, r.cms));
      });
    },
    setCms(cid) {
      if (!cid) return (this.cms = null);
      var self = this;
      this.getAllGroupsAndMembers(cid, function(data) {
        self.cms = data.cms;
      });
    },
    startLoading() {
      if (this.$refs.btn) this.$refs.btn.startLoading();
    },
    stopLoading() {
      if (this.$refs.btn) this.$refs.btn.stopLoading();
    },
  },
};

export default plugin;
